"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1682 4H14v2h2.1682l.3787 2.0451-2.2098-.5892c-1.4169-.3779-2.8512.5466-3.0922 1.993a.4856.4856 0 0 1-.5326.4028l-6.111-.679C3.2136 9.0185 2 10.1047 2 11.5009v.7047l5.6727 2.026A2 2 0 0 1 9 16.1151v.6533h-.9577C7.4398 15.7121 6.3031 15 5 15c-1.933 0-3.5 1.567-3.5 3.5S3.067 22 5 22c1.2879 0 2.4133-.6956 3.021-1.7316h2.3851l7.1216-6.9268.3417 1.845C16.4912 15.6568 15.5 16.9626 15.5 18.5c0 1.933 1.567 3.5 3.5 3.5s3.5-1.567 3.5-3.5c0-1.6255-1.108-2.9921-2.61-3.3858l-.5765-3.1133H21V9.2326l-2.3134-.6169-.5519-2.9799C17.9592 4.6878 17.1323 4 16.1682 4zM6.5 18.5c0-.8284-.6716-1.5-1.5-1.5s-1.5.6716-1.5 1.5S4.1716 20 5 20s1.5-.6716 1.5-1.5zM19 20c-.8284 0-1.5-.6716-1.5-1.5S18.1716 17 19 17s1.5.6716 1.5 1.5S19.8284 20 19 20z"
  })];
};

exports.default = _default;